<script>
    import Fa from 'svelte-fa';
    import { faHeartBroken } from '@fortawesome/pro-regular-svg-icons';
    import { page } from '$app/stores';
    import * as ErrorComponents from '$lib/components/ErrorPages/index.js';

    import PageHeader from '$lib/components/PageHeader.svelte';
    import Button from '$lib/components/Button.svelte';

    let CustomErrorComponent = null;
    if ($page?.error?.code && ErrorComponents[$page.error.code]) {
        CustomErrorComponent = ErrorComponents[$page.error.code];
    } else if ($page?.error?.message === 'Not Found') {
        CustomErrorComponent = ErrorComponents['DEFAULT_NOT_FOUND'];
    }
</script>

<svelte:head>
    <title>{$page?.error?.message || CustomErrorComponent || 'Error'} | Caktus Vape</title>
</svelte:head>

<div class="container px-3">
    <PageHeader title=" " shareButton={false} searchButton={true} classes="px-2 py-8 lg:px-0" />

    <Fa icon={faHeartBroken} class="m-auto mb-10 block text-[8rem]" />

    {#if CustomErrorComponent}
        <svelte:component this={CustomErrorComponent} data={$page.error} />
    {:else}
        <div class="m-auto max-w-sm text-center">
            <h1 class="text-2xl font-semibold dark:text-purple-300">{$page?.error?.message || 'Error'}</h1>
            <p class="py-7 text-lg">An error has occured, try freshing the page<br /> or navigate back to home using the button below.</p>
            <Button style="Primary" href="/">Go Home</Button>
        </div>
    {/if}
</div>
